import $ from 'jquery';
import mdModal from 'mdmodal';

var dummyBackground;

class DummyBackground {
    constructor() {
        this.element = $(
            '<div class="modal-backdrop fade" style="display:none;"></div>'
        );
    }

    add() {
        this.element.show();
    }

    remove() {
        this.element.hide();
    }

    show() {
        this.element.addClass('in');
    }

    hide() {
        this.element.removeClass('in');
    }
}

dummyBackground = new DummyBackground();

mdModal.config.main = {
    header: true,
    width: '100%',
};

mdModal.config.classes = {
    layout: 'modal fade',
    container: 'modal-dialog',
    contentWrap: '',
    content: 'ui-modal-content',
    loader: 'message-box-loader loading',
    header: 'ui-modal-header',
    title: 'ui-modal-header-title',
    closeButton: 'ui-modal-header-close sf-close-alt3',
    footer: 'ui-modal-footer',
    footerButton: 'btn btn-default ui-modal-footer-btn',
};

mdModal.config.styles = {
    container: '',
    contentWrap: '',
    content: '',
    title: '',
};

mdModal.config.templates = {
    footerButton: `<a class="{{ classes }}"
            {% if styles not empty %}
                style="{{ styles }}
            {% endif %}"
        >{{ text }}</a>`,
    closeButton: `<a class="{{ classes }}"
            {% if styles not empty %}
                style="{{ styles }}
            {% endif %}"
        ></a>`,
};

mdModal.config.effects.add({
    beforeBackgroundShow: () => {
        dummyBackground.add();
    },
    backgroundShow: () => {
        dummyBackground.show();
    },
    beforeBackgroundHide: () => {
        dummyBackground.hide();
    },
    backgroundHide: () => {
        dummyBackground.remove();
    },
    // beforeShow: null,
    show: (box) => {
        $(box.background()).addClass('in');
    },
    beforeHide: (box) => {
        $(box.background()).removeClass('in');
    },
    // hide: null,
});

$(() => {
    dummyBackground.element.appendTo($('body'));
});

export default mdModal;
